import React from "react";

/**
 * Input Component
 * Reusable input field with consistent styling matching original CSS
 * 
 * @param {string} type - Input type (text, email, etc.)
 * @param {string} name - Input name
 * @param {string} value - Input value
 * @param {string} placeholder - Input placeholder
 * @param {function} onChange - Change handler
 * @param {boolean} error - Error state
 * @param {string} errorMessage - Error message to display
 * @param {string} className - Additional classes
 */
const Input = ({
  type = "text",
  name,
  value,
  placeholder,
  onChange,
  error = false,
  errorMessage,
  className = "",
  ...props
}) => {
  return (
    <div className="mb-3">
      <input
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className={`w-full pl-3 font-roboto font-normal text-[0.731rem] leading-[0.688rem] text-[#2b2b2b] h-[1.596rem] border ${
          error ? "border-[#EF5464]" : "border-[#808080]"
        } rounded-[0.3rem] focus:outline-none ${className}`}
        {...props}
      />
      {error && errorMessage && (
        <p className="m-0 text-[#EF5464] text-[0.60rem] py-[5px] whitespace-nowrap">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default Input;
